import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { showMutationError } from "@/lib/mutation-error";
import { partnerApiService } from "@/services/partner-api.service";

export const useRemoveMember = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (memberId: string) => partnerApiService.removeMember(memberId),
		onSuccess: () => {
			toast.success("Member removed");
			queryClient.invalidateQueries({ queryKey: ["partner", "members"] });
		},
		onError: (err) => {
			showMutationError(err, "Failed to remove member");
		},
	});
};
